import { useMutation } from '@apollo/client';
import {
  UPDATE_CUSTOM_ROLE,
  UpdateCustomRoleInput,
  UpdateCustomRoleResponse,
} from '../../../../apollo/queries/v3/RolesNPermissions/updateCustomRole.queries';
import { CONFLICT } from '../../../../utils/constants';
import { RNPToastHelper } from '../../RNPToaster';

type Props = {
  onComplete: () => void;
};

type ReturnType = [(input: UpdateCustomRoleInput) => void];

const useEditCustomRoleAPI = ({ onComplete }: Props): ReturnType => {
  const [editCustomRole] = useMutation(UPDATE_CUSTOM_ROLE, {
    onCompleted: (res: UpdateCustomRoleResponse) => {
      if (res.updateCustomRole) {
        onComplete();
      }
    },
    onError: (e: any) => {
      if (
        e.graphQLErrors &&
        e.graphQLErrors.length > 0 &&
        e.graphQLErrors[0].validationErrors?.status === CONFLICT
      ) {
        RNPToastHelper.conflictError();
      } else {
        RNPToastHelper.error();
      }
    },
  });

  const editRole = (input: UpdateCustomRoleInput) => {
    const options = {
      variables: {
        input,
      },
    };

    editCustomRole(options);
  };

  return [editRole];
};

export default useEditCustomRoleAPI;
